export default [
	{
        path: '/buy-orders',
        component: () => import('../components/OrdersParent.vue'),
        meta: {                  
        },
        children:[
            {
                path: '/buy-orders',
                component: () => import('../components/BuyOrders.vue'),
                name: 'buy-orders',
            },
            {
                path: '/buy-orders-info/:id',
                component: () => import('../components/partials/BuyOrderInfo.vue'),
                name: 'buy-orders-info',
            },

            {
                path: '/rent-orders',
                component: () => import('../components/RentOrders.vue'),
                name: 'rent-orders',
            },
            {
                path: '/rent-orders-info/:id',
                component: () => import('../components/partials/RentOrderInfo.vue'),
                name: 'rent-orders-info',
            },

            {
                path: '/custom-orders',
                component: () => import('../components/CustomOrder.vue'),
                name: 'custom-orders',
            },
            {
                path: '/custom-orders-info/:id',
                component: () => import('../components/partials/CustomOrderInfo.vue'),
                name: 'custom-orders-info',
            },

        ]
    },
    
    {
        path: '/profile-info/:id',
        component: () => import('../components/partials/ProfileInfo.vue'),
        name: 'profile-info',
    },
    

]